export default __webpack_public_path__ + "static/media/seating-capacity.efdb8394.svg";